/* eslint-disable react/prop-types */
import React, { FC } from "react";
import { Check } from "lucide-react";

interface Props {
	variant: string;
	label?: string;
	isSelected?: boolean;
	onChange?: () => void;
}

const BannerButtonVariant: FC<Props> = ({
	variant,
	label,
	isSelected = false,
	onChange
}) => {
	const isPrimary = variant === "black";
	const defaultLabel = isPrimary ? "Solid fill" : "Ghost";
	const buttonLabel = label || defaultLabel;
	const testVariant = isPrimary ? "primary" : "primaryOutline";

	return (
		<label className="cursor-pointer text-center">
			<input
				type="radio"
				checked={isSelected}
				onChange={() => onChange?.()}
				aria-label={`button-variant-${variant}`}
				className="sr-only"
			/>
			<div
				className={[
					"relative p-2 rounded-lg transition-all",
					isSelected
						? "border-2 border-primary bg-primary-lighter"
						: "border border-border bg-white hover:border-border hover:shadow-sm"
				].join(" ")}
				data-testid="button-container"
			>
				{isSelected && (
					<span className="absolute -top-2 -right-2 h-5 w-5 bg-primary text-white rounded-full flex items-center justify-center">
						<Check className="h-3 w-3" />
					</span>
				)}
				<span
					aria-hidden={true}
					style={{ display: "none" }}
					data-testid="test-variant"
					role="note"
				>
					{testVariant}
				</span>
				<button
					type="button"
					className={[
						"pointer-events-none px-6 h-9 rounded-full text-sm",
						isPrimary
							? "bg-black text-white"
							: "border border-foreground bg-white text-foreground"
					].join(" ")}
				>
					{buttonLabel}
				</button>
			</div>
			<span
				className={[
					"block text-[11px] mt-1 transition-opacity",
					isSelected ? "text-primary font-medium" : "text-transparent"
				].join(" ")}
			>
				Selected
			</span>
		</label>
	);
};

export default BannerButtonVariant;
